import React, { useState } from 'react';
import PhoneBase from '../../Interface/PhoneBase/PhoneBase';
import TabsUI from '../../Interface/TabsUI';
import InprogressInventoryTransfer from './InprogressInventoryTransfer';
import NewInventoryTransfer from './NewInventoryTransfer';
import { Typography } from '@mui/material';

const InventoryTransferPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'Új indítása',
      content: <NewInventoryTransfer />,
    },
    {
      id: 1,
      name: 'Folyamatban',
      content: <InprogressInventoryTransfer />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  return (
    <PhoneBase name="InventoryTransfer">
      <Typography variant="h5" sx={{ fontWeight: 400, py: 1, px: 2 }}>
        Készletáttárolás
      </Typography>
      <TabsUI activeTab={activeTab} handleTabClick={handleTabClick} disablePadding>
        {tabs.map((tab, index) => (
          <div key={index} name={tab.name}>
            {tab.content}
          </div>
        ))}
      </TabsUI>
    </PhoneBase>
  );
};

export default InventoryTransferPage;
